<template>
  <div class="check-bot-kks-cell">
    <check-bot-established-kks
      class="small"
      :is-validating-kks="isValidatingKks.value"
      :kks-list="getKks()"
      :kks-validation-list="kksValidationList.value"
      @kks-clicked="handleKksClicked"
    ></check-bot-established-kks>
  </div>
</template>

<script lang="ts">
  import { Ref, defineComponent } from 'vue';
  import CheckBotEstablishedKks from '@/components/CheckBotEstablishedKks/CheckBotEstablishedKks.vue';
  import { IDocumentMetadata, IKksValidationResultDto } from 'types';

  export default defineComponent({
    components: { CheckBotEstablishedKks },

    props: {
      calculateRowHeightFunction: {
        type: Function,
        required: true,
      },
      data: {
        type: Array as () => IDocumentMetadata[],
        required: true,
      },
      documentObjectIdsByDocumentIds: {
        type: Object as () => Record<string, string>,
        required: true,
      },
      isValidatingKks: {
        type: Object as () => Ref<boolean>,
        default: () => ({ value: false }),
      },
      kksValidationList: {
        type: Object as () => Ref<IKksValidationResultDto[]>,
        default: () => {},
      },
      model: {
        type: Object as () => IDocumentMetadata,
        required: true,
      },
      prop: {
        type: String,
        required: true,
      },
      rowIndex: {
        type: Number,
        required: true,
      },
      updateMetadataFunction: {
        type: Function,
        required: true,
      },
    },

    mounted() {
      this.calculateRowHeightFunction();
    },

    methods: {
      getKks(): string[] {
        return this.model[this.prop];
      },

      getDocumentObjectId(): string {
        const documentId = this.model.documentId;
        return this.documentObjectIdsByDocumentIds[documentId];
      },

      handleKksClicked(kks: string): void {
        this.updateMetadataFunction(kks, this.model.documentId);
      },
    },
  });
</script>

<style lang="scss" scoped>
  .check-bot-kks-cell {
    overflow: auto;
    padding: 1rem 0;

    max-height: 200px;
  }
</style>
